'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "onClick", "onClickRemove", "removeLabel", "selectedColorSet"];
import React, { useCallback } from 'react';
import { ChipInputItem } from "./index.styled.mjs";
import { IconX } from "../../../core/components/Icon/icons/IconX/index.mjs";
import { warn } from "../../../core/logging.mjs";
import { addColorSet } from "../../../core/styles/index.mjs";
export var TagInputItem = function TagInputItem(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    onClickRemove = _ref.onClickRemove,
    removeLabel = _ref.removeLabel,
    _ref$selectedColorSet = _ref.selectedColorSet,
    selectedColorSet = _ref$selectedColorSet === void 0 ? 'base' : _ref$selectedColorSet,
    attributes = _objectWithoutProperties(_ref, _excluded);
  var handleClick = useCallback(function (event) {
    if (onClickRemove) {
      onClickRemove(event);
    } else if (onClick) {
      onClick(event);
    }
  }, [onClick, onClickRemove]);
  warn('The Tag component has been deprecated. Please use the Chip component instead.');
  return /*#__PURE__*/React.createElement(ChipInputItem, Object.assign({
    "aria-checked": true,
    "aria-label": "".concat(removeLabel, " ").concat(children),
    iconTrailing: onClickRemove ? IconX : null,
    className: addColorSet(selectedColorSet)
  }, attributes, {
    onClick: handleClick
  }), children);
};